/**
 * AguaClara Studio – small behaviours on top of Dawn.
 *
 * Same-page anchor links in the mobile drawer (e.g. "/#philosophy" while on "/").
 * Dawn's MenuDrawer has no link handler, so the drawer stays open (and the body
 * keeps its overflow-hidden-* class) after the browser jumps to the anchor.
 * We close it through the drawer's own closeMenuDrawer(event, summary), which
 * also releases the focus trap and the header's "menu-open" state.
 */
(function () {
  function closeDrawerForSamePageAnchor(event) {
    var link = event.target.closest('.menu-drawer a[href*="#"]');
    if (!link) return;

    var url;
    try {
      url = new URL(link.getAttribute('href'), window.location.href);
    } catch (e) {
      return;
    }
    if (url.pathname !== window.location.pathname || !url.hash) return;

    var drawer = link.closest('header-drawer, menu-drawer');
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;

    var details = drawer.querySelector('details');
    var summary = details && details.querySelector('summary');
    if (!details || !summary || !details.hasAttribute('open')) return;

    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', false);

    // Belt and braces: Dawn keys the body class on data-breakpoint; clear both.
    document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
  }

  document.addEventListener('click', closeDrawerForSamePageAnchor);
})();
